const isEnvFlagEnabled = (value: string | undefined): boolean => value === "true";

export const isSftpEnabled = (): boolean =>
  isEnvFlagEnabled(process.env.REACT_APP_ENABLE_SFTP);

export const isProductPaymentLinksEnabled = (): boolean =>
  isEnvFlagEnabled(process.env.REACT_APP_ENABLE_PRODUCT_PAYMENT_LINKS);
